<script setup lang="ts">
defineProps<{ noAlignment?: boolean; noPadding?: boolean }>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <PageContainerAlignment :no-alignment :no-padding>
    <slot />
  </PageContainerAlignment>
</template>
